import daBoiAvatar from '../client/static/da-boi.webp';
import kivo from '../client/static/examples/kivo.webp';
import messync from '../client/static/examples/messync.webp';
import microinfluencerClub from '../client/static/examples/microinfluencers.webp';
import promptpanda from '../client/static/examples/promptpanda.webp';
import reviewradar from '../client/static/examples/reviewradar.webp';
import scribeist from '../client/static/examples/scribeist.webp';
import searchcraft from '../client/static/examples/searchcraft.webp';
import { BlogUrl, DocsUrl } from '../shared/common';

export interface GridFeature {
  name: string;
  description: string;
  emoji: string;
  href: string;
  size?: 'small' | 'medium' | 'large';
}

export const features: GridFeature[] = [
  {
    name: 'Center & Organization Directory',
    description: 'Discover Centers, Community schools, charities, and Member organizations across every province in Canada.',
    emoji: '🏢',
    href: DocsUrl,
    size: 'large',
  },
  {
    name: 'Cross-Community Interaction',
    description: 'Connect with Member communities beyond your city. Share resources, collaborate on events, and support one another nationwide.',
    emoji: '🤝',
    href: DocsUrl,
    size: 'large',
  },
  {
    name: 'Community Notices',
    description: 'Share announcements, weekly reminders, holiday schedules, and important updates with your congregation.',
    emoji: '📢',
    href: DocsUrl,
    size: 'medium',
  },
  {
    name: 'Event Management',
    description: 'Organize community lectures, holiday celebrations, charity drives, and community gatherings with RSVP support.',
    emoji: '📅',
    href: DocsUrl,
    size: 'medium',
  },
  {
    name: 'Local Business Listings',
    description: 'Showcase local restaurants, community bookstores, and Member-owned businesses within your community.',
    emoji: '🏪',
    href: DocsUrl,
    size: 'small',
  },
  {
    name: 'Lost & Found',
    description: 'Help community members recover lost items at the Center or community events.',
    emoji: '🔍',
    href: DocsUrl,
    size: 'small',
  },
  {
    name: 'Buy & Sell Marketplace',
    description: 'A trusted marketplace for the community — from books to clothing and more.',
    emoji: '💸',
    href: DocsUrl,
    size: 'small',
  },
  {
    name: 'Facility Booking',
    description: 'Reserve prayer halls, classrooms, and community rooms with real-time availability tracking.',
    emoji: '🏗️',
    href: DocsUrl,
    size: 'medium',
  },
];

export const testimonials = [
  {
    name: 'Ahmed Hassan',
    role: 'Center Administrator, Toronto',
    avatarSrc: daBoiAvatar,
    socialUrl: '',
    quote: "App has brought our congregation closer together. We can share weekly announcements, organize community events, and connect with Member families across Ontario — all in one place.",
  },
  {
    name: 'Fatima Al-Rashid',
    role: 'Principal, Community Academy, Vancouver',
    avatarSrc: daBoiAvatar,
    socialUrl: '',
    quote: 'Our school uses App to communicate with parents, post school notices, and coordinate with other community schools across BC. It has made a huge difference in how connected our community feels.',
  },
  {
    name: 'Yusuf Osman',
    role: 'Community Member, Calgary',
    avatarSrc: daBoiAvatar,
    socialUrl: '#',
    quote: 'Finding local community organizations, events, and connecting with the broader Member community in Calgary has never been easier. App truly feels like a home for Canadian Members.',
  },
];

export const faqs = [
  {
    id: 1,
    question: 'Who is App for?',
    answer: 'App is built for the community in Canada — Centers, community schools, Member charities, social services, and individual community members who want to stay connected and engaged.',
  },
  {
    id: 2,
    question: 'Can my Center or organization create a profile?',
    answer: 'Yes! Any Center, community school, charity, or Member organization across Canada can register and claim their listing, making it officially maintained. Unclaimed listings may still appear with community-sourced information.',
  },
  {
    id: 3,
    question: 'How does the access system work?',
    answer: 'Public information is discoverable by anyone browsing the portal. Registered members gain deeper access to community features, private notices, and direct interaction with organizations they follow.',
  },
  {
    id: 4,
    question: 'Can community members interact across different cities?',
    answer: 'Absolutely. App is designed to bridge Member communities across Canada. You can discover organizations in any province, follow events nationwide, and participate in the broader Canadian Member community.',
  },
  {
    id: 5,
    question: 'Is App free to use?',
    answer: 'Yes! App is completely free for both organizations and community members. Sign up and start connecting with the Member community across Canada today.',
  },
];

export const footerNavigation = {
  app: [
    { name: 'Documentation', href: DocsUrl },
    { name: 'Blog', href: BlogUrl },
  ],
  company: [
    { name: 'About App', href: '/about' },
    { name: 'Roadmap', href: '/roadmap' },
    { name: 'Privacy Policy', href: '/privacy' },
    { name: 'Terms of Service', href: '/terms' },
    { name: 'Contact', href: '/contact' },
  ],
};

export const examples = [
  {
    name: 'Center & Community Centre',
    description: 'Browse schedules, weekly notices, community events, and announcements — listed by the community or directly by the organization.',
    imageSrc: kivo,
    href: '#',
  },
  {
    name: 'Community School',
    description: 'Keep parents informed with school notices, academic events, and direct communication channels across the community.',
    imageSrc: messync,
    href: '#',
  },
  {
    name: 'Member Charity & Non-Profit',
    description: 'Raise awareness for fundraising campaigns, volunteer opportunities, and charity events visible to Members across Canada.',
    imageSrc: microinfluencerClub,
    href: '#',
  },
  {
    name: 'Local Business Directory',
    description: 'List local restaurants, community bookstores, and other Member-owned businesses.',
    imageSrc: promptpanda,
    href: '#',
  },
  {
    name: 'Community Student Association',
    description: 'Connect university students with events, study spaces, and the local community around campus.',
    imageSrc: reviewradar,
    href: '#',
  },
  {
    name: 'Community Cultural Centre',
    description: 'Promote cultural programs, language classes, study circles, and interfaith initiatives to the wider community.',
    imageSrc: scribeist,
    href: '#',
  },
  {
    name: 'Funeral Services',
    description: 'Provide funeral and burial information to community members in their time of need.',
    imageSrc: searchcraft,
    href: '#',
  },
];



